const Expenses = () => {
  return (
    <main>
      <h2>Expenses</h2>
    </main>
  );
};

export default Expenses;
